<template>
  <div class="calico-card-page">
    <div class="calico-card-container">
      <div class="calico-card-row">
        <div style="width: 500px;">
          <CalicoStoryCard
            :score="10"
            title="Timely Payments"
            :description="description"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 500px;">
          <CalicoStoryCard
            :score="-10"
            title="Timely Payments"
            :description="description"
          />
        </div>
      </div>
      <div class="calico-card-row">
        <div style="width: 500px;">
          <CalicoStoryCard
            :score="0"
            title="Timely Payments"
            :description="description"
          />
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import CalicoStoryCard from '@/components/calico/storyCard/index.vue';
  
  export default {
    name: 'CalicoCardPage',
    components: {
        CalicoStoryCard,
    },
    data() {
      return {
        description: 'Duis adipiscing convallis condimentum eget. Malesuada sed enim sociis arcu sem eget ultrices tristique. Cursus gravida proin varius est semper.'
      };
    },
  };
  </script>
  
  <style lang="scss">
  .calico-card-page {
    display: flex;
    justify-content: center;
    align-items: center;
    .calico-card-container {
      @include stack-space($space-large);
      @include inset-space($space-large);
      width: 100%;
      .calico-card-row {
        @include inline-space($space-large);
        @include inset-space($space-large);
      }
    }
  }
  </style>